import React from "react";
import PropTypes from "prop-types";
import { defaultTemplate } from "core/hoc";
import { BasicInput, BaasicFieldDropdown, DatePickerField } from "core/components";
import { ApplicationEditLayout, Content } from "core/layouts";

const TrackingCaseEditTemplate = function({ trackingCaseEditViewStore }) {
	const {
		contentLoading,
		form,
		facilityStore,
		localPatientStore,
		itemCategoryStore,
		productStore,
		caseStatusStore,
		isEdit,
		insuranceCompanyStore
	} = trackingCaseEditViewStore;
	return (
		<ApplicationEditLayout store={trackingCaseEditViewStore}>
			<Content loading={contentLoading}>
				<div className="row">
                    <div className="col col-sml-12 col-lrg-8">
                        <div className="card card--form card--primary card--med">
                            <div className="row">
								<div className="form__group col col-lrg-6 u-mar--bottom--sml">
									<BaasicFieldDropdown field={form.$('patientId')} store={localPatientStore} />
								</div>
								<div className="form__group col col-lrg-6 u-mar--bottom--sml">
									<BaasicFieldDropdown field={form.$('facilityId')} store={facilityStore} />
								</div>
								<div className="form__group col col-lrg-6 u-mar--bottom--sml">
									<BaasicFieldDropdown field={form.$('itemCategoryId')} store={itemCategoryStore} />
								</div>
								<div className="form__group col col-lrg-6 u-mar--bottom--sml">
									<BaasicFieldDropdown field={form.$('trackingCaseProducts')} store={productStore} />
								</div>
								<div className="form__group col col-lrg-6 u-mar--bottom--sml">
									<BaasicFieldDropdown field={form.$('payorSource')} store={insuranceCompanyStore} />
								</div>
								<div className="form__group col col-lrg-6 u-mar--bottom--sml">
									<BasicInput field={form.$('reference')} />
								</div>
								<div className="form__group col col-lrg-6 u-mar--bottom--sml">
									<DatePickerField field={form.$('validFrom')} />
								</div>
								<div className="form__group col col-lrg-6 u-mar--bottom--sml">
									<DatePickerField field={form.$('validTo')} />
								</div>
								{isEdit && <div className="form__group col col-lrg-6 u-mar--bottom--sml">
									<BaasicFieldDropdown field={form.$('caseStatusId')} store={caseStatusStore} />
								</div>}
							</div>
						</div>
					</div>
				</div>
			</Content>
		</ApplicationEditLayout>
	);
};

TrackingCaseEditTemplate.propTypes = {
	trackingCaseEditViewStore: PropTypes.object.isRequired,
	t: PropTypes.func
};

export default defaultTemplate(TrackingCaseEditTemplate);